import { Badge } from "@/components/ui/badge";
import { reconciliationMessages } from "@/services/messages";
import type { ReconciliationStatus } from "@efes/shared";

interface StatusBadgeProps {
	status: ReconciliationStatus;
}

const STATUS_TONE: Record<ReconciliationStatus, "neutral" | "info" | "success" | "error"> = {
	draft: "neutral",
	running: "info",
	completed: "success",
	failed: "error",
};

const STATUS_LABEL_KEY: Record<ReconciliationStatus, keyof typeof reconciliationMessages> = {
	draft: "status_draft",
	running: "status_running",
	completed: "status_completed",
	failed: "status_failed",
};

/**
 * Бейдж со статусом набора сверки (FR-006a жизненный цикл).
 * Тексты — из `messages.reconciliation.status_*`.
 */
export function StatusBadge({ status }: StatusBadgeProps) {
	const label = reconciliationMessages[STATUS_LABEL_KEY[status]];
	const tone = STATUS_TONE[status];
	const variant = status === "completed" ? "strong" : "pill";
	return (
		<Badge variant={variant} tone={tone} className={status === "running" ? "animate-pulse" : ""}>
			{label}
		</Badge>
	);
}
